import React from "react";
import { Box, Grid, Typography, Divider, Chip } from "@mui/material";
import { getUserData } from "../../../../Base/helper/baseFunctions";

const Field = ({ label, value }) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === false
  ) {
    value = "—";
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Typography
        sx={{
          fontSize: 13,
          color: "text.primary",
          fontWeight: 600,
          mb: 0.5,
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontSize: 14,
          color: "text.secondary",
        }}
      >
        {value}
      </Typography>
    </Grid>
  );
};

const Section = ({ title, children }) => (
  <Box sx={{ mb: 3, p: 1 }}>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: 16,
        mb: 2,
        color: "inherit",
      }}
    >
      {title}
    </Typography>

    <Grid container spacing={2}>
      {children}
    </Grid>

    <Divider sx={{ mt: 2 }} />
  </Box>
);

const JobReview = ({
  jobPostData,
  description,
  rolesresponsibilities,
  videoQuestions = [],
  preScreenQuestions = [],
  toggle,
  isGroupOrgFlowTrue,
}) => {
  const userData = getUserData();
  const getSkills = (skills) => skills?.map((s) => s.skill).join(", ") || "—";
  const isAIJob = Boolean(jobPostData?.is_ai_job);

  return (
    <Box>
      {/* STEP 1 */}
      <Section title="Job Basics">
        {!toggle && <Field
          label={isGroupOrgFlowTrue ? "Group Org" : "Client"}
          value={getClientValue({
            toggle,
            isGroupOrgFlowTrue,
            jobPostData,
            userData,
          })}
        />}

        <Field
          label="Hiring Partner"
          value={jobPostData?.consultancy_id
            ?.map((c) => c.consultancy)
            .join(", ")}
        />

        <Field
          label="Primary Recruiter"
          value={jobPostData?.primary_recruiter_id?.recruiter}
        />

        <Field
          label="Industry"
          value={jobPostData?.industry_type?.industry_name}
        />

        <Field label="Job Title" value={jobPostData?.title?.job_title} />
        <Field label="Department" value={jobPostData?.businessunit_fk?.name} />
      </Section>

      {/* STEP 2 */}
      <Section title="Requirements & Workflow">
        <Field
          label="Primary Skills"
          value={getSkills(jobPostData?.primary_skill)}
        />
        <Field
          label="Secondary Skills"
          value={getSkills(jobPostData?.secondary_skill)}
        />
        <Field label="Vacancies" value={jobPostData?.vaccancies} />
        <Field label="Job Location" value={jobPostData?.job_location} />
        <Field label="Minimum Experience" value={jobPostData?.min_exp_required} />
        <Field label="Maximum Experience" value={jobPostData?.max_exp_required} />
        <Field label="Minimum Salary" value={jobPostData?.min_salary} />
        <Field
          label="Public Job"
          value={jobPostData?.make_public ? "Yes" : "No"}
        />

        <Field
          label="Offer Letter Workflow"
          value={jobPostData?.offer_letter ? "Yes" : "No"}
        />
        {jobPostData?.offer_letter && (
          <>
            <Field
              label="Offer Letter Template"
              value={
                jobPostData?.offer_letter_template_id?.offer_letter_template_name || "-"
              }
            />
            <Field
              label="Primary Approver"
              value={
                jobPostData?.approver_ats_users_id?.name || "-"
              }
            />
            {Boolean(jobPostData?.second_approver_ats_users_id) && (
              <Field
                label="Secondary Approver"
                value={
                  jobPostData?.second_approver_ats_users_id?.name || "-"
                }
              />
            )}
          </>
        )}
      </Section>

      {/* STEP 3 */}
      <Section title="Job Description">
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: 13,
              color: "text.primary",
              fontWeight: 600,
              mb: 0.5,
            }}
          >
            Description
          </Typography>

          <Box
            sx={{ pl: 2, color: "text.secondary" }}
            dangerouslySetInnerHTML={{
              __html: description || "—",
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: 13,
              color: "text.primary",
              fontWeight: 600,
              mb: 0.5,
            }}
          >
            Roles & Responsibilities
          </Typography>

          <Box
            sx={{ pl: 2, color: "text.secondary" }}
            dangerouslySetInnerHTML={{
              __html: rolesresponsibilities || "—",
            }}
          />
        </Grid>
      </Section>

      {/* STEP 4 */}
     {isAIJob && <Section title="Pre-Screen Questions">
        {preScreenQuestions.length === 0 ? (
          <Field label="Questions" value="No questions added" />
        ) : (
          <Grid item xs={12}>
            {preScreenQuestions.map((q, i) => (
              <Chip key={i} label={q.label} sx={{ mr: 1, mb: 1 }} />
            ))}
          </Grid>
        )}
      </Section>}

      {/* STEP 5 */}
      {isAIJob && <Section title="Video Questions">
        {videoQuestions.length === 0 ? (
          <Field label="Questions" value="No video questions added" />
        ) : (
          <Grid item xs={12}>
            {videoQuestions.map((q, i) => (
              <Chip
                key={i}
                label={`${q.question} (${q.time})`}
                sx={{ mr: 1, mb: 1 }}
              />
            ))}
          </Grid>
        )}
      </Section>}
    </Box>
  );
};

const getClientValue = ({
  toggle,
  isGroupOrgFlowTrue,
  jobPostData,
  userData,
}) => {
  if (toggle === false) {
    // External job
    if (isGroupOrgFlowTrue) {
      return jobPostData?.ats_grouporg_id?.name || "—";
    } else {
      return jobPostData?.ats_company_id?.company || "—";
    }
  } else {
    // Internal job
    if (isGroupOrgFlowTrue) {
      if (userData?.user_type === "Group User") {
        return userData?.ats_grouporg_name || "Internal";
      }

      return ["", null, false, "Internal"].includes(
        jobPostData?.ats_grouporg_id,
      )
        ? "Internal"
        : jobPostData?.ats_grouporg_id?.name || "Internal";
    } else {
      return ["", null, false, "Internal"].includes(jobPostData?.ats_company_id)
        ? "Internal"
        : jobPostData?.ats_company_id?.company || "Internal";
    }
  }
};

export default JobReview;
